import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

interface AppBarProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
  flat?: boolean;
  children?: ReactNode;
}

/** Header sticky com safe-area (RF-UX-062). Um h1 por tela (RF-UX-087). */
export function AppBar({ title, subtitle, left, right, className, flat, children }: AppBarProps) {
  return (
    <header className={cx("appbar", flat && "appbar-flat", className)}>
      {left}
      {children ?? (
        <div className="min-w-0 flex-1">
          {title ? (
            typeof title === "string" ? (
              <h1 className="appbar-title truncate">{title}</h1>
            ) : (
              title
            )
          ) : null}
          {subtitle ? <div className="appbar-sub truncate">{subtitle}</div> : null}
        </div>
      )}
      {right}
    </header>
  );
}
